const STORAGE_KEY = 'bhg-telemetry-client';

/**
 * Stable per-browser anonymous identifier for TelemetryDeck.
 * Hashed by the SDK before upload — not PII, but distinguishes unique visitors.
 */
export function getOrCreateAnonymousTelemetryClientUser(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) {
      return existing;
    }

    const id =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `anon-${Date.now()}-${Math.random().toString(36).slice(2)}`;

    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return `ephemeral-${Date.now()}`;
  }
}
